<template>
  <el-dialog title="What are these gifts ? 🎁" :visible.sync="open" :before-close="close" width="452px">
    <div class="flex flex-wrap mb-6">
      <p class="text-gray-800 font-inter font-bold text-lg">If you enable gifts:</p>
      <p class="mt-2">
        They will replace points 1, 4 and 7 as follows:
      </p>
      <img
        src="../../../../assets/img/group621.png"
        style="height: 181px; width: 412px; flex-shrink: 0;"
        class="mx-auto mt-2"
      />
      <ul class="list-disc ml-6">
        <li class="mt-2">
          The number of gifts distributed per day is determined based on the total number of gifts you have and the
          duration of your wheel.
          <p class="italic list-disc ml-6 text-gray-400">
              For example, if you have 300 gifts and your wheel lasts 30 days, 10 gift will be distributed per day. Once
              the 10 gifts are distributed, the wheel only offers points.
          </p>
        </li>
        <li class="mt-2">
          If there are no gifts available for the day or if your stock is empty, users will earn points.
        </li>
        <li class="mt-2">
          You can adjust the number of gifts available in stock, but you cannot withdraw those already won.
        </li>
      </ul>
      <p class="mt-4 text-gray-800 font-inter font-bold text-lg">If you disable gifts:</p>
      <p class="mt-2">
        You can disable gifts, but then your users will only earn points
      </p>
      <img
        src="../../../../assets/img/group361.png"
        style="height: 36px; width: 412px; flex-shrink: 0;"
        class="mx-auto mt-2"
      />
    </div>
    <div class="flex flex-row-reverse">
      <button
        @click="close()"
        class="loader-button px-4 py-2 gap-2 rounded bg-green-500 text-blue-50 max-w-max shadow-sm hover:shadow-md"
      >
        Ok
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FormWheelInfo',
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    close() {
      return this.$emit('close', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wheels/ui/modal/gift-info.vue